export default __webpack_public_path__ + "static/color-picker-role-dont-09bca788bd1734c58cb34630eed4dda8e2c662c11e4dbb46000064c06e16e822.png";